import { useTranslation } from 'next-i18next'

import { HelpToggleType } from '~/bootcamp/types/bootcamp.types'

import ExclamationStrokeIcon from '~/components/Icons/svgs/ExclamationStrokeIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'

const HelpToggleButton = ({
  onClick,
  className = '',
  toggleType = HelpToggleType.bootcamp,
  size = 24,
}: {
  onClick: () => void
  className?: string
  toggleType?: HelpToggleType
  size?: number
}): React.ReactElement => {
  const { t } = useTranslation('generics')
  const defaultStyle = toggleType === HelpToggleType.bootcamp ? 'border-purple bg-white' : 'border-white bg-purple'
  const iconColor = toggleType === HelpToggleType.bootcamp ? 'text-purple' : 'text-white'

  return (
    <button
      aria-label={t('ariaLabelButtons.info')}
      className={`border-2 rounded-full w-9 h-9 flex items-center justify-center shadow-rounded-button ${defaultStyle} ${className}`}
      onClick={onClick}
    >
      <SVGIcon icon={ExclamationStrokeIcon} pathClassName={iconColor} size={size} />
    </button>
  )
}

export default HelpToggleButton
